<template>
  <div class="not-found" style="font-size: 50px">Not Found</div>
</template>
